import React, { useState, useEffect } from 'react';
import { FaRegWindowClose, FaExclamationTriangle } from 'react-icons/fa';

//services
import AppMeterGroupsService from '../../AppMeterGroupsService';

//global component
import ModalButton from '../../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
  SelectStyles,
  ModalNoteStyles,
} from '../../../../SharedStyles';

const PhaseModal = (props) => {
  const { handleCloseModal, handleDataChange } = props;
  const { strings } = AppMeterGroupsService;
  const [phase, setPhase] = useState('');

  useEffect(() => {
    setPhase(props.phase);
  }, [props.phase]);

  const closeModal = () => {
    handleCloseModal();
  };

  const handleChange = (e) => {
    setPhase(e.target.value);
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    handleDataChange('phaseType', phase);
    handleCloseModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.phasePowerTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0'>
            <p>{strings.phasePowerContent}</p>
          </ModalItemStyles>
          {/* Section */}
          <form id='modalForm' onSubmit={handleSaveInfo}>
            <ModalItemStyles>
              <SelectStyles
                type='text'
                onChange={handleChange}
                name='phase'
                placeholder={strings.phasePlaceholder}
                value={phase || ''}>
                {strings.phasePowerOptions.map((option, index) => {
                  return (
                    <option key={index} value={index + 1}>
                      {option}
                    </option>
                  );
                })}
              </SelectStyles>
            </ModalItemStyles>
          </form>
          {/* Note Section */}
          <ModalNoteStyles>
            <p className='Warning-modal'>
              <FaExclamationTriangle />
              <span className='Warning-bold'>{strings.warning}: </span>
              {strings.phasePowerWarning}
            </p>
          </ModalNoteStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          formSubmit='modalForm'
          buttonText={strings.ok}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default PhaseModal;
